export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    SUCCESS_AUTO_CLOSE_OFF : 'SUCCESS_AUTO_CLOSE_OFF',
    ERROR_AUTO_CLOSE_OFF : 'ERROR_AUTO_CLOSE_OFF',
    ERROR: 'ALERT_ERROR',
    INFO: 'ALERT_INFO',
    CLEAR: 'ALERT_CLEAR'
};
